import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivateChild,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { Globals } from "../../app.globals";

@Injectable()
export class PublicFormAuth implements CanActivateChild {
    private router: Router;
    private http: HttpClient;
    private globals: Globals;

    constructor(router: Router, http: HttpClient, globals: Globals) {
        this.router = router;
        this.http = http;
        this.globals = globals;
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        return this.isAllowedAccess(childRoute);
    }

    private async isAllowedAccess(
        route: ActivatedRouteSnapshot
    ): Promise<boolean> {
        var result: boolean = false;
        var isView: boolean = route.data.state.includes("view");
        var url =
            "api/PublicFormAuthorization/" +
            route.data.formArea +
            "/" +
            route.params.projectId +
            "/" +
            route.params.formId +
            "/" +
            route.queryParams.securityToken +
            "/" +
            isView;

        try {
            this.globals.showSpinner();
            var data = await this.http
                .get(url, { responseType: "text" })
                .toPromise();
            this.globals.hideSpinner();
            if (data != null) {
                let access = data.toLowerCase();

                if (access == "true") result = true;
            }
        } catch (err) {
            console.log(err);
        }

        if (!result)
            this.router.navigateByUrl(
                "/unauthorized?security=quality-assurance"
            );

        return result;
    }
}
